import muiAddObjObj from "./muiAddObjObj.js";
import muiAddObjString from "./muiAddObjString.js";
import muiAddString from "./muiAddString.js";

/**
 *
 * @param {{name:color, name2:color2, ...}} [object] paletteColorsObject name of the palette and color
 * @returns {generatedColors} object with light theme and dark theme
 * @example
 * const templates = tmc({primary:"#000000", cusColor:"#0000FF"})
 * <ThemeProvider theme={isDarkTheme ? createTheme(templates.dark) : createTheme(templates.light)}>
 * @description create object with light theme and dark theme for mui createTheme
 * it will setup the mode and colors automatically.
 * provide object with palette name and color.
 * add "!" to color to put the darker color in light theme and vise versa
 */
const muiTemplate = (paletteColorsObject = {}) => {
  let lightTheme = {
      palette: {
        mode: "light",
      },
    },
    darkTheme = {
      palette: {
        mode: "dark",
      },
    };
  for (const [colorName, colorValue] of Object.entries(paletteColorsObject)) {
    if (typeof colorValue === "string" || Array.isArray(colorValue)) {
      if (colorName.includes(".")) {
        muiAddObjString(lightTheme, darkTheme, colorName, colorValue);
      } else {
        muiAddString(lightTheme, darkTheme, colorName, colorValue);
      }
    } else {
      muiAddObjObj(lightTheme, darkTheme, colorName, colorValue);
    }
  }
  return {
    light: lightTheme,
    dark: darkTheme,
  };
};

export default muiTemplate;
